function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/** Keeps track of raw listeners added to the base elements to avoid duplication */
var ledger = new WeakMap();

function editLedger(wanted, baseElement, callback, setup) {
  var _a, _b;

  if (!wanted && !ledger.has(baseElement)) {
    return false;
  }

  var elementMap = (_a = ledger.get(baseElement)) !== null && _a !== void 0 ? _a : new WeakMap();
  ledger.set(baseElement, elementMap);

  if (!wanted && !ledger.has(baseElement)) {
    return false;
  }

  var setups = (_b = elementMap.get(callback)) !== null && _b !== void 0 ? _b : new Set();
  elementMap.set(callback, setups);
  var existed = setups.has(setup);

  if (wanted) {
    setups.add(setup);
  } else {
    setups["delete"](setup);
  }

  return existed && wanted;
}

function isEventTarget(elements) {
  return typeof elements.addEventListener === 'function';
}

function safeClosest(event, selector) {
  var target = event.target;

  if (target instanceof Text) {
    target = target.parentElement;
  }

  if (target instanceof Element && event.currentTarget instanceof Element) {
    // `.closest()` may match ancestors of `currentTarget` but we only need its children
    var closest = target.closest(selector);

    if (closest && event.currentTarget.contains(closest)) {
      return closest;
    }
  }
} // This type isn't exported as a declaration, so it needs to be duplicated above


function delegate(base, selector, type, callback, options) {
  // Handle Selector-based usage
  if (typeof base === 'string') {
    base = document.querySelectorAll(base);
  } // Handle Array-like based usage


  if (!isEventTarget(base)) {
    var subscriptions = Array.prototype.map.call(base, function (element) {
      return delegate(element, selector, type, callback, options);
    });
    return {
      destroy: function destroy() {
        var _iterator = _createForOfIteratorHelper(subscriptions),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subscription = _step.value;
            subscription.destroy();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };
  } // `document` should never be the base, it's just an easy way to define "global event listeners"


  var baseElement = base instanceof Document ? base.documentElement : base; // Handle the regular Element usage

  var capture = Boolean(_typeof(options) === 'object' ? options.capture : options);

  var listenerFn = function listenerFn(event) {
    var delegateTarget = safeClosest(event, selector);

    if (delegateTarget) {
      event.delegateTarget = delegateTarget;
      callback.call(baseElement, event);
    }
  };

  var setup = JSON.stringify({
    selector: selector,
    type: type,
    capture: capture
  });
  var isAlreadyListening = editLedger(true, baseElement, callback, setup);
  var delegateSubscription = {
    destroy: function destroy() {
      baseElement.removeEventListener(type, listenerFn, options);
      editLedger(false, baseElement, callback, setup);
    }
  };

  if (!isAlreadyListening) {
    baseElement.addEventListener(type, listenerFn, options);
  }

  return delegateSubscription;
}

export default delegate;